import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DotElasticComponent } from './dot-elastic.component';



@NgModule({
  declarations: [DotElasticComponent],
  imports: [
    CommonModule
  ],
  exports:[DotElasticComponent],
  entryComponents:[DotElasticComponent]
})
export class DotElasticModule { }
